import { render, staticRenderFns } from "./BookingPopover.vue?vue&type=template&id=94b4439c&scoped=true"
import script from "./BookingPopover.vue?vue&type=script&lang=js"
export * from "./BookingPopover.vue?vue&type=script&lang=js"
import style0 from "./BookingPopover.vue?vue&type=style&index=0&id=94b4439c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b4439c",
  null
  
)

export default component.exports